import React, { useEffect } from 'react';
import classNames from 'classnames';
import * as styles from './content.module.scss';
import childrenWithProps from '@/lib/childrenWithProps';
// intersection observer
import { useInView } from 'react-intersection-observer';

interface ContainerTypeKeyValues {
  className?: { wrapper?: string | string[]; inner?: string | string[] };
  intersection?: { visible?: string; standby?: string; threshold?: number; initialInView?: boolean; callback?: Function };
}

interface ContainerTypes {
  className?: string[] | string;
  intersection?: undefined;
}

const Container: React.FC<ContainerTypes | ContainerTypeKeyValues> = ({ className = '', intersection, children }) => {
  const classNameProps = className as ContainerTypeKeyValues['className'];
  const wrapper = classNameProps?.wrapper ? classNameProps.wrapper : classNameProps;
  const inner = classNameProps?.inner ? classNameProps.inner : null;
  const visible = intersection?.visible || styles.visible;
  const standby = intersection?.standby || styles.standby;
  const threshold = intersection?.threshold || 0.5;
  const initialInView = intersection?.initialInView || false;

  const { ref, inView } = useInView({
    threshold,
    initialInView,
    triggerOnce: true,
  });

  const wrapperStyle = classNames(styles.lContent, inView ? visible : standby, ...[wrapper]);
  const innerStyle = classNames(styles.lContent__inner, ...[inner]);

  useEffect(() => {
    intersection?.callback && intersection.callback(!!!inView);
  }, [inView]);

  return (
    <section ref={ref} className={wrapperStyle}>
      <div className={innerStyle}>{childrenWithProps({ children, additionalProps: { inView } })}</div>
    </section>
  );
};

export default Container;

export const ContainerWithoutInner: React.FC<ContainerTypes | ContainerTypeKeyValues> = ({
  className = '',
  intersection,
  children,
}) => {
  const classNameProps = className as ContainerTypeKeyValues['className'];
  const wrapper = classNameProps?.wrapper ? classNameProps.wrapper : classNameProps;
  const visible = intersection?.visible || styles.visible;
  const standby = intersection?.standby || styles.standby;
  const threshold = intersection?.threshold || 0.5;
  const initialInView = intersection?.initialInView || false;

  const { ref, inView } = useInView({
    threshold,
    initialInView,
    triggerOnce: true,
  });

  const wrapperStyle = classNames(styles.lContent, inView ? visible : standby, ...[wrapper]);

  return (
    <section ref={ref} className={wrapperStyle}>
      {childrenWithProps({ children, additionalProps: { inView } })}
    </section>
  );
};
